import { Injectable, inject } from '@angular/core';

import { HttpService } from '@shared/services';
import { PresetAllocation, PresetDocument, PresetModule } from './api-models/entity-templates.model';

type EntityTemplateRequestParams = {
  id: number;
  moduleId: number;
};

@Injectable({
  providedIn: 'root',
})
export class EntityTemplatesService {
  private http = inject(HttpService);

  getPresetDocumentDetails({ id, moduleId }: Pick<EntityTemplateRequestParams, 'id' | 'moduleId'>) {
    const params = this.http.buildHttpParams({ id });
    return this.http.get<PresetDocument>('_api/EntityTemplates/Get', {
      httpOptions: {
        params,
        headers: { moduleId: moduleId.toString() },
      },
    });
  }

  getPresetModules(entityInstanceId: number) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.get<PresetModule[]>('_api/EntityTemplates/ModulesWithPresetsDict', {
      httpOptions: { params },
      useLoader: false,
    });
  }

  getContractPresets(entityInstanceId: number, moduleId: number) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.get<PresetAllocation[]>('_api/EntityTemplates/PresetModuleContractEIAllocationDict', {
      httpOptions: { params, headers: { moduleId: moduleId.toString() } },
      useLoader: false,
    });
  }

  syncContractPresets(entityInstanceId: number, moduleId: number, selectedPresetIds: number[]) {
    const params = this.http.buildHttpParams({ contractId: entityInstanceId });
    return this.http.post<void>('_api/EntityTemplates/SyncPresetsWithContractEIModule', selectedPresetIds, {
      httpOptions: { params, headers: { moduleId: moduleId.toString() } },
      useLoader: false,
    });
  }
}
